import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import {Album} from '../model/Album';
import {LogService} from './LogService';
import {Artist} from '../model/Artist';
import {ArtistSummary} from '../model/ArtistSummary';
import {shareReplay} from 'rxjs/operators';
import { AlbumSummary } from '../model/AlbumSummary';
import { ArtistSummaryWithAlbums } from '../model/ArtistSummaryWithAlbums';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class MusicCollectionService {

  private static readonly URL_BASE = 'assets/json';
  private readonly artistCollectionCachedObservable: Observable<Array<ArtistSummary>>;
  private readonly artistCollectionWithAlbumsCachedObservable: Observable<Array<ArtistSummaryWithAlbums>>;

  constructor(
    private http: HttpClient,
    private logService: LogService) {
    console.log('in MusicCollectionService constructor');
    /* 
       the largest non-image data we get is the full artist and album collection json, 
       so we use caching to only get it once, even if we navigate away from the top-level
       pages to child pages. otherwise there is a noticeable loading indicator every time 
       we go to the artists or albums page. although we set this here, the actual API call 
       doesn't happen until the components that call getArtistSummaryCollection() and
       getArtistSummaryWithAlbumsCollection() subscribe to it. could have cached it multiple ways
       but wanted to try out shareReplay().
     */
    this.artistCollectionCachedObservable = this.getAllArtistsSortedByArtist().pipe(shareReplay(1));
    this.artistCollectionWithAlbumsCachedObservable = this.getAllArtistsWithAlbumsSortedByArtist().pipe(shareReplay(1));
  }

  getArtistSummaryCollection(): Observable<Array<ArtistSummary>> {
    return this.artistCollectionCachedObservable;
  }

  getArtistSummaryWithAlbumsCollection(): Observable<Array<ArtistSummaryWithAlbums>> {
    return this.artistCollectionWithAlbumsCachedObservable;
  }

  getArtist(artistId: string): Observable<Artist> {
    const url = MusicCollectionService.URL_BASE + `/artists/${artistId}/artist.json`;
    return this.http.get<Artist>(url, httpOptions);
  }

  getAlbum(artistId: string, albumId: string): Observable<Album> {
    const url = MusicCollectionService.URL_BASE + `/artists/${artistId}/albums/${albumId}.json`;
    return this.http.get<Album>(url, httpOptions);
  }

  getAlbumsForArtist(artistId: string): Observable<Array<AlbumSummary>> {
    const url = MusicCollectionService.URL_BASE + `/artists/${artistId}/albums.json`;
    return this.http.get<Array<AlbumSummary>>(url, httpOptions);
  }

  getAllArtistsSortedByArtist(): Observable<Array<ArtistSummary>> {
    const url = MusicCollectionService.URL_BASE + '/artistCollectionSortedByArtist.json';
    return this.http.get<Array<ArtistSummary>>(url, httpOptions);
  }

  getAllArtistsWithAlbumsSortedByArtist(): Observable<Array<ArtistSummaryWithAlbums>> {
    const url = MusicCollectionService.URL_BASE + '/artistCollectionWithAlbumsSortedByArtist.json';
    return this.http.get<Array<ArtistSummaryWithAlbums>>(url, httpOptions);
  }

}
